import React from 'react';
import moment from 'moment';
import Pagination from '../common/Pagination';

const DonationTable = ({
  donationList,
  currentPage,
  itemsPerPage,
  onPageChange,
  handleItemClick
}) => {
  const getCurrentItems = (items) => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return items?.slice(indexOfFirstItem, indexOfLastItem);
  };

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title fw-bold mb-3">Donation List</h5>
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead className="table-light">
              <tr>
                <th scope="col">Donor Name</th>
                <th scope="col">Amount</th>
                <th scope="col">Status</th>
                <th scope="col">Transaction ID</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {getCurrentItems(
                [...donationList].sort(
                  (a, b) =>
                    new Date(b.response?.create_time) -
                    new Date(a.response?.create_time)
                )
              ).map((item) => (
                <tr key={item.id}>
                  <td>{item.full_name}</td>
                  <td>
                    {item.amount} {item.currency_code}
                  </td>
                  <td>
                    <span
                      className={`badge bg-${item.status === "COMPLETED"
                          ? "success"
                          : "warning"
                        }`}
                    >
                      {item.status}
                    </span>
                  </td>
                  <td>{item.id}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-info"
                      onClick={() => handleItemClick(item, "donation")}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={currentPage}
          totalItems={donationList.length}
          itemsPerPage={itemsPerPage}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default DonationTable; 